import React, {useCallback, useEffect, useState} from 'react';
import {Checkbox} from 'antd';
import {useIntl} from 'react-intl';
import {connect} from 'react-redux';
import BoldText from '../../../common/text/BoldText';
import {getFilters} from '../../../../selectors/interventionsSelector';

const CheckboxGroup = Checkbox.Group;

const EMPTY_VALUE = '__EMPTY__';

const FilterCheckbox = ({options: optionsProp, emptyValueFilter, apiKey, filter, contentUpdater, filters}) => {
  const intl = useIntl();

  const [selectedAll, setSelectedAll] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);

  const getOptions = useCallback(() => {
    const options = [...optionsProp];
    if (emptyValueFilter) {
      options.unshift({label: `(${intl.formatMessage({id: 'none'})})`, value: EMPTY_VALUE});
    }
    return options;
  }, [optionsProp, emptyValueFilter, intl]);

  useEffect(() => {
    const current = filters[apiKey];
    setSelectedFilters(current);
    setSelectedAll(current && current.length === getOptions().length);
  }, [filters, apiKey, getOptions]);

  const filterOnChange = (checkedValues) => {
    setSelectedFilters(checkedValues);
  };

  const filterConfirm = () => {
    filter.selectedKeys[0] = selectedFilters;
    (selectedFilters && selectedFilters.length > 0) ? filter.confirm() : filter.clearFilters();
    contentUpdater({[apiKey]: selectedFilters});
  };

  const filterSelectAll = () => {
    const newSelectedAll = !selectedAll;
    setSelectedFilters(newSelectedAll ? getOptions().map(i => i.value) : []);
    setSelectedAll(newSelectedAll);
  };

  const options = getOptions();

  return (
    <div className='dropdown dropdown--sm dropdown--bottom-right'>
      <div className='dropdown--checkbox'>
        <Checkbox checked={selectedAll} onClick={filterSelectAll}>
          <BoldText text={`(${intl.formatMessage({id: 'intervention.status.ALL'})})`}/>
        </Checkbox>
      </div>
      <CheckboxGroup value={selectedFilters} onChange={filterOnChange} options={options}/>
      <div className='dropdown--checkbox'>
        <button type='primary' className='btn btn-outline' onClick={filterConfirm}>
          {intl.formatMessage({id: 'menu.apply'})}
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  filters: getFilters(state),
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FilterCheckbox);
